import type { NavigateFunction } from 'react-router-dom';

let navigateFn: NavigateFunction | null = null;
let setShowArchiveFn: ((show: boolean) => void) | null = null;

export const setAppNavigate = (navigate: NavigateFunction) => {
    navigateFn = navigate;
};

export const appNavigate = (to: string) => {
    if (navigateFn) {
        navigateFn(to);
        return;
    }
    window.location.assign(to);
};

/** Регистрируется в TodosSider, чтобы баннеры могли переключать режим списка */
export const setArchiveViewController = (fn: ((show: boolean) => void) | null) => {
    setShowArchiveFn = fn;
};

export const setArchiveView = (show: boolean) => {
    setShowArchiveFn?.(show);
};
